/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BlogCategory } from './BlogCategory';
import {
    BlogCategoryFromJSON,
    BlogCategoryFromJSONTyped,
    BlogCategoryToJSON,
    BlogCategoryToJSONTyped,
} from './BlogCategory';
import type { SECIndividual } from './SECIndividual';
import {
    SECIndividualFromJSON,
    SECIndividualFromJSONTyped,
    SECIndividualToJSON,
    SECIndividualToJSONTyped,
} from './SECIndividual';
import type { Prosecution } from './Prosecution';
import {
    ProsecutionFromJSON,
    ProsecutionFromJSONTyped,
    ProsecutionToJSON,
    ProsecutionToJSONTyped,
} from './Prosecution';

/**
 * 
 * @export
 * @interface BlogPost
 */
export interface BlogPost {
    /**
     * 
     * @type {string}
     * @memberof BlogPost
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof BlogPost
     */
    excerpt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogPost
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof BlogPost
     */
    author?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BlogPost
     */
    publishDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BlogPost
     */
    readTime?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BlogPost
     */
    tags?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BlogPost
     */
    featured?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof BlogPost
     */
    views: number;
    /**
     * 
     * @type {string}
     * @memberof BlogPost
     */
    image?: string | null;
    /**
     * 
     * @type {Array<SECIndividual>}
     * @memberof BlogPost
     */
    relatedAttorneys?: Array<SECIndividual>;
    /**
     * 
     * @type {number}
     * @memberof BlogPost
     */
    id: number;
    /**
     * 
     * @type {Array<BlogCategory>}
     * @memberof BlogPost
     */
    categories?: Array<BlogCategory>;
    /**
     * 
     * @type {Array<Prosecution>}
     * @memberof BlogPost
     */
    relatedProsecutions?: Array<Prosecution>;
    /**
     * 
     * @type {Date}
     * @memberof BlogPost
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BlogPost
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the BlogPost interface.
 */
export function instanceOfBlogPost(value: object): value is BlogPost {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('publishDate' in value) || value['publishDate'] === undefined) return false;
    if (!('views' in value) || value['views'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function BlogPostFromJSON(json: any): BlogPost {
    return BlogPostFromJSONTyped(json, false);
}

export function BlogPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogPost {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'excerpt': json['excerpt'] == null ? undefined : json['excerpt'],
        'content': json['content'],
        'author': json['author'] == null ? undefined : json['author'],
        'publishDate': (new Date(json['publish_date'])),
        'readTime': json['read_time'] == null ? undefined : json['read_time'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'featured': json['featured'] == null ? undefined : json['featured'],
        'views': json['views'],
        'image': json['image'] == null ? undefined : json['image'],
        'relatedAttorneys': json['related_attorneys'] == null ? undefined : ((json['related_attorneys'] as Array<any>).map(SECIndividualFromJSON)),
        'id': json['id'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(BlogCategoryFromJSON)),
        'relatedProsecutions': json['related_prosecutions'] == null ? undefined : ((json['related_prosecutions'] as Array<any>).map(ProsecutionFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function BlogPostToJSON(json: any): BlogPost {
    return BlogPostToJSONTyped(json, false);
}

export function BlogPostToJSONTyped(value?: BlogPost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'excerpt': value['excerpt'],
        'content': value['content'],
        'author': value['author'],
        'publish_date': ((value['publishDate']).toISOString().substring(0,10)),
        'read_time': value['readTime'],
        'tags': value['tags'],
        'featured': value['featured'],
        'views': value['views'],
        'image': value['image'],
        'related_attorneys': value['relatedAttorneys'] == null ? undefined : ((value['relatedAttorneys'] as Array<any>).map(SECIndividualToJSON)),
        'id': value['id'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(BlogCategoryToJSON)),
        'related_prosecutions': value['relatedProsecutions'] == null ? undefined : ((value['relatedProsecutions'] as Array<any>).map(ProsecutionToJSON)),
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

